module.exports = __webpack_public_path__ + "static/wireframeFallback@2x-59f5773d5f22d8c198447c545bc2b6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/wireframeFallback@2x.png
// module id = 2629
// module chunks = 168707334958949